import React from 'react';
import { string } from 'prop-types';

const IconLodging = props => {
  return (
    <svg
      width={'22'}
      height={'22'}
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 512 512"
      version="1.1"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <g>
            <path
              fill="#84B75B"
              d="M504.5 437.798c0 10.26-1.96 20.06-5.51 29.05H352.06c-3.56-8.99-5.52-18.79-5.52-29.05 0-41.37 31.81-75.31 72.3-78.7 2.2-.19 4.43-.28 6.68-.28 43.62 0 78.98 35.36 78.98 78.98z"
            ></path>
            <path
              fill="#69A833"
              d="M461.03 447.998c0 6.45-.96 12.77-2.86 18.85H352.06c-3.56-8.99-5.52-18.79-5.52-29.05 0-41.37 31.81-75.31 72.3-78.7v29.27c24.55 8.7 42.19 32.14 42.19 59.63z"
            ></path>
          </g>
          <g>
            <path
              fill="#A0D37D"
              d="M159.945 466.845c3.558-8.991 5.514-18.791 5.514-29.048 0-43.619-35.36-78.98-78.98-78.98-43.619 0-78.98 35.36-78.98 78.98 0 10.257 1.956 20.057 5.514 29.048h146.932z"
            ></path>
          </g>
          <g>
            <path
              fill="#EBEEF2"
              d="M406.842 195.668L406.842 466.843 86.482 466.843 86.482 195.668 246.662 51.852z"
            ></path>
            <path fill="#D3D8DF" d="M165.283 466.843L406.842 225.273 406.842 466.843z"></path>
            <g>
              <g fill="#7FB7EA">
                <path d="M363.619 310.012h-18.491c-5.673 0-10.273 4.599-10.273 10.273v87.338h39.036v-87.338c0-5.674-4.599-10.273-10.272-10.273z"></path>
                <path d="M158.469 407.622v-87.338c0-5.673-4.599-10.273-10.273-10.273h-18.491c-5.673 0-10.273 4.599-10.273 10.273v87.338"></path>
              </g>
            </g>
            <path fill="#5F9EEB" d="M86.48 407.622H406.845V466.844H86.48z"></path>
            <path fill="#5F9EEB" d="M86.482 407.621H406.842V466.842H86.482z"></path>
            <path
              fill="#3A82D0"
              d="M406.842 407.621L406.842 466.843 165.283 466.843 224.504 407.621z"
            ></path>
            <path
              fill="#7B8C98"
              d="M296.864 320.284v146.559H196.46V320.284c0-5.673 4.599-10.273 10.273-10.273h79.859c5.673.001 10.272 4.6 10.272 10.273z"
            ></path>
            <path
              fill="#627687"
              d="M296.864 335.251L296.864 466.843 196.46 466.843 196.46 435.665z"
            ></path>
            <g>
              <path
                fill="#5F9EEB"
                d="M422.116 256.874L246.662 99.348 71.209 256.874c-4.222 3.79-10.716 3.44-14.507-.781l-17.156-19.109c-3.79-4.222-3.44-10.716.781-14.507l190.894-171.39c8.784-7.887 22.098-7.887 30.882 0l190.895 171.389c4.222 3.79 4.571 10.285.781 14.507l-17.156 19.109c-3.791 4.222-10.286 4.572-14.507.782z"
              ></path>
            </g>
            <circle cx="246.662" cy="228.503" r="41.046" fill="#EB5777"></circle>
          </g>
          <g>
            <path
              fill="#A0D37D"
              d="M445.454 466.845a51.105 51.105 0 003.578-18.848c0-28.302-22.943-51.245-51.245-51.245-28.302 0-51.245 22.943-51.245 51.245a51.105 51.105 0 003.578 18.848h95.334z"
            ></path>
          </g>
        </g>
        <g>
          <path d="M425.521 351.317c-3.742 0-7.478.267-11.176.745v-32.54c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v69.769c-.52-.014-1.036-.04-1.559-.04a58.56 58.56 0 00-16.395 2.345v-71.313c0-9.8-7.973-17.772-17.773-17.772h-18.49c-9.8 0-17.772 7.973-17.772 17.772v79.838h-22.991v-79.838c0-9.8-7.973-17.772-17.772-17.772h-79.859c-9.8 0-17.772 7.973-17.772 17.772v79.838h-22.991v-79.838c0-9.8-7.973-17.772-17.772-17.772h-18.49c-9.8 0-17.772 7.973-17.772 17.772v79.838H93.979V246.509l152.683-137.082 152.683 137.082v40.352c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-26.884l2.761 2.479c7.293 6.546 18.551 5.939 25.098-1.352l17.157-19.11c6.545-7.292 5.939-18.549-1.352-25.096l-81.986-73.609a7.5 7.5 0 00-10.022 11.161l81.986 73.609a2.776 2.776 0 01.211 3.915l-17.157 19.11a2.777 2.777 0 01-3.915.211L251.673 93.767a7.498 7.498 0 00-10.021 0L66.198 251.292a2.765 2.765 0 01-2.001.706 2.758 2.758 0 01-1.914-.917l-17.157-19.108a2.776 2.776 0 01.211-3.916l190.895-171.39a15.587 15.587 0 0120.861 0l84.594 75.95a7.501 7.501 0 0010.022-11.161l-84.594-75.95a30.563 30.563 0 00-40.904 0L35.315 216.896c-7.291 6.547-7.896 17.805-1.352 25.097l17.157 19.109a17.653 17.653 0 0012.27 5.874c.327.018.652.026.978.026 4.386 0 8.563-1.596 11.852-4.549l2.76-2.478v91.666c-16.194 1.379-31.477 7.222-44.576 17.117a7.499 7.499 0 004.526 13.485 7.469 7.469 0 004.515-1.516c10.471-7.91 22.635-12.677 35.535-14.012v92.628H18.303C16.109 452.406 15 445.179 15 437.796c0-12.168 3.125-24.196 9.036-34.783a7.499 7.499 0 00-2.892-10.205A7.499 7.499 0 0010.94 395.7C3.783 408.518 0 423.074 0 437.796c0 10.979 2.032 21.681 6.041 31.809a7.499 7.499 0 006.974 4.74h485.971a7.5 7.5 0 006.974-4.74c4.009-10.128 6.041-20.83 6.041-31.809-.001-47.685-38.796-86.479-86.48-86.479zm-83.166-31.033a2.775 2.775 0 012.772-2.772h18.49a2.776 2.776 0 012.773 2.772v78.098a59.572 59.572 0 00-2.586 1.74h-21.45v-79.838zm6.77 94.838a58.408 58.408 0 00-10.084 32.875c0 3.841.374 7.632 1.102 11.348h-35.778v-44.223h44.76zm-142.393-97.61h79.859a2.776 2.776 0 012.772 2.772v139.061H203.96V320.284a2.775 2.775 0 012.772-2.772zm-79.798 2.772a2.775 2.775 0 012.772-2.772h18.49a2.776 2.776 0 012.772 2.772v79.838h-24.035v-79.838zM93.979 459.345v-44.223h94.98v44.223H93.979zm312.866 0h-51.32a43.783 43.783 0 01-1.483-11.348c0-24.122 19.624-43.746 43.745-43.746s43.745 19.624 43.745 43.746c0 3.871-.497 7.67-1.483 11.348h-33.204zm86.852 0H455.43a58.94 58.94 0 001.101-11.348c0-26.643-17.834-49.185-42.187-56.354v-24.45a72.255 72.255 0 0111.176-.876c39.414 0 71.479 32.065 71.479 71.479.001 7.383-1.108 14.61-3.302 21.549z"></path>
          <path d="M272.344 404.434a7.5 7.5 0 007.5-7.5v-8.507c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v8.507c0 4.143 3.357 7.5 7.5 7.5z"></path>
          <path d="M198.116 228.503c0 26.769 21.777 48.546 48.546 48.546s48.546-21.778 48.546-48.546-21.777-48.546-48.546-48.546-48.546 21.778-48.546 48.546zm82.092 0c0 18.498-15.049 33.546-33.546 33.546S213.116 247 213.116 228.503s15.049-33.546 33.546-33.546 33.546 15.049 33.546 33.546z"></path>
        </g>
      </g>
    </svg>
  );
};

IconLodging.defaultProps = { className: null };

IconLodging.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconLodging;
